import { ProvisioningEnum } from '@lib/resources/types';

export const LS_HUB_SHOW_MENTION_BANNER = 'lh:hub_show_mention_banner';

export const REF_PROVISIONING = {
  // Providers provisioned to TH only should be able to see reminder msgs
  reminder: { provisioning: [ProvisioningEnum.Reminder, ProvisioningEnum.Telehealth] },
  'appointment-offer': { provisioning: ProvisioningEnum.Waitlist },
  waitlist: { provisioning: ProvisioningEnum.Waitlist },
  // TODO / TEMP: as of 2020-05-13 the patientReminderCancellationThanks
  // carries the ref waitlist-offer in order to make NLP work to let patients reply
  // WAITLIST to join from the cancel thanks message; so for now treat the provisining
  // as a reminder so people can see the cancel thanks message in the UI
  // https://lumahealth.slack.com/archives/C03T0T6QA/p1589491163101600
  // Providers provisioned to TH only should be able to see reminder msgs
  'waitlist-offer': { provisioning: [ProvisioningEnum.Reminder, ProvisioningEnum.Telehealth] },
  'feedback-reminder': { provisioning: ProvisioningEnum.Feedback },
  feedback: { provisioning: ProvisioningEnum.Feedback },
  'referral-reminder': { provisioning: ProvisioningEnum.Referral },
  'referral-followup': { provisioning: ProvisioningEnum.Referral },
  broadcast: { provisioning: ProvisioningEnum.Broadcast },
  // NOTE these had `provisioning: 'hub'`, which doesn't exist,
  // so it's been changed to `ProvisioningEnum.Chat`
  // https://github.com/lumahealthhq/web-app/commit/67c82148ef39e10de9dc31630c54f8548551bc21
  chat: { provisioning: ProvisioningEnum.Chat },
  'chat-notification': { provisioning: ProvisioningEnum.Chat },
  'pin-verification': { provisioning: ProvisioningEnum.Waitlist },
  followup: { provisioning: ProvisioningEnum.Followup },
  'bot:followup': { provisioning: ProvisioningEnum.Followup },
  'referral-redirect': { provisioning: ProvisioningEnum.Referral },
  'form-reminder': { provisioning: ProvisioningEnum.Form },
};

export const VISIBILITY_INTERNAL = 'internal';
export const VISIBILITY_PUBLIC = 'public';
